import { throttle } from 'lodash-es';

import helpers, { READ_MORE_CARD_ID } from './helpers';

const SCROLL_EVENT_TROTTLE_TIME = 0;

export const init = ($newsYouCanUse) => {
  // DOM Elements
  const $cards = $newsYouCanUse.querySelectorAll('.c-extended-card');
  const getHeroMediaWrapper = () => document.querySelector('.c-hero__media-wrapper');
  const $playerHero = getHeroMediaWrapper().querySelector('.c-player-card');
  const $readMoreCard = document.querySelector(`#${READ_MORE_CARD_ID}.c-extended-card--read-more`);

  // Hide link to the same content on "read more" card (if needed)
  if ($readMoreCard) {
    helpers.handleHideReadMoreContent($readMoreCard);
  }

  // Catch possible query params
  const cardIdQueryParam = helpers.getCardIdFromUrl($cards);
  if (cardIdQueryParam) {
    helpers.handleCardIdFromUrl($cards, cardIdQueryParam);
  }

  // Init Listeners
  window.addEventListener(
    'scroll',
    throttle(
      () =>
        helpers.handleScrolling({
          $newsYouCanUse,
          $cards,
          $heroMediaWrapper: getHeroMediaWrapper(),
          $playerHero,
          $readMoreCard,
        }),
      SCROLL_EVENT_TROTTLE_TIME
    )
  );
};
